<template>
  <CContainer fluid>
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>Dev People Logs Sync</CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="4">
                <label>Search</label>
                <CInput
                  v-model="filters.search"
                  placeholder="name or email"
                  @keyup.enter="applyFilter"
                />
              </CCol>
              <CCol sm="4" class="d-flex align-items-end">
                <CButton color="info" class="mr-2" @click="applyFilter">Apply</CButton>
                <CButton color="secondary" @click="resetFilter">Reset</CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <CCard>
          <CCardBody>
            <div class="table-responsive">
              <table class="table table-bordered table-sm">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Status</th>
                    <th>Active</th>
                    <th>people_status_movement</th>
                    <th>peoples_activity</th>
                    <th>peoples_log</th>
                    <th>sync_result_preview</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in rows" :key="row.people_uuid">
                    <td>{{ row.name || '-' }}</td>
                    <td>{{ row.email || '-' }}</td>
                    <td>{{ row.status || '-' }}</td>
                    <td>
                      <CBadge :color="row.active === 'Active' ? 'success' : 'danger'">
                        {{ row.active || '-' }}
                      </CBadge>
                    </td>
                    <td>
                      <pre class="json-preview">{{ formatPreview(row.people_status_movement) }}</pre>
                    </td>
                    <td>
                      <pre class="json-preview">{{ formatPreview(row.peoples_activity) }}</pre>
                    </td>
                    <td>
                      <pre class="json-preview">{{ formatPreview(row.peoples_log) }}</pre>
                    </td>
                    <td>
                      <pre class="json-preview">{{ formatPreview(row.sync_result_preview) }}</pre>
                    </td>
                  </tr>
                  <tr v-if="rows.length === 0">
                    <td colspan="8" class="text-center">No data</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="d-flex justify-content-between align-items-center">
              <div>
                Showing {{ meta.from || 0 }} - {{ meta.to || 0 }} of {{ meta.total || 0 }}
              </div>
              <b-pagination
                v-model="page"
                :total-rows="meta.total || 0"
                :per-page="perPage"
                @change="loadData"
              ></b-pagination>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import devService from '@/services/dev'

export default {
  data() {
    return {
      rows: [],
      meta: {},
      page: 1,
      perPage: 10,
      filters: {
        search: ''
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    buildParams() {
      return {
        page: this.page,
        per_page: this.perPage,
        search: this.filters.search
      }
    },
    loadData() {
      devService.getDevPeopleLogsSync(this.buildParams())
        .then((res) => {
          const data = res.data || {}
          this.rows = data.rows || []
          this.meta = data
        })
        .catch((err) => {
          alert((err.response && err.response.data && err.response.data.message) || 'Failed to load data')
        })
    },
    applyFilter() {
      this.page = 1
      this.loadData()
    },
    resetFilter() {
      this.filters = {
        search: ''
      }
      this.page = 1
      this.loadData()
    },
    formatPreview(value) {
      if (!value) return 'No Data'
      try {
        return JSON.stringify(value, null, 2)
      } catch (e) {
        return String(value)
      }
    }
  }
}
</script>

<style scoped>
.json-preview {
  white-space: pre-wrap;
  font-size: 12px;
  max-width: 420px;
  margin: 0;
}
</style>
